<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <vx-card title="알림톡 발송내역">
            <div class="tb_box">
                <table id="list" style="width:100%;min-width:1400px;" class="border-collapse calendar">
                    <colgroup>
                        <col width="10%" />
                        <col width="10%" />
                        <col width="*" />
                        <col width="5%" />
                        <col width="10%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">발송코드</th>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">연락처</th>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">발송내용</th>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">발송상태</th>
                            <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">발송날짜</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in list" :key="index">
                            <td class="border border-solid d-theme-border-grey-light text-center">{{ item.CMID }}</td>
                            <td class="border border-solid d-theme-border-grey-light text-center">{{ item.DEST_PHONE }}</td>
                            <td class="border border-solid d-theme-border-grey-light text-left" style="padding:20px;">{{ item.MSG_BODY }}</td>
                            <td class="border border-solid d-theme-border-grey-light text-center">
                                <span v-if="item.STATUS == 1 || 2">
                                    발송성공
                                </span>
                                <span v-else-if="item.STATUS == 0">
                                    발송대기
                                </span>
                                <span v-else>
                                    오류
                                </span>
                            </td>
                            <td class="border border-solid d-theme-border-grey-light text-center">{{ $moment(item.SEND_TIME).format('YYYY-MM-DD HH:mm:ss') }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br />
            <vs-pagination :total="total_page" v-model="page" @input="history()" :max="7"></vs-pagination>
        </vx-card>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import moment from 'moment';
export default {
    data() {
        return {
            page: 1,
            total_page: 0,
            list: [],
            width: window.innerWidth,
        };
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
        },

        init() {
            this.history();
        },
        async history() {
            const params = {
                page: this.page,
            };
            const { data } = await axiosClass.get('/api/management/kakaoHistory', params, true);
            console.log(data);
            this.list = data.list;
            this.total_page = data.pageCount;
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.init();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<style></style>
